import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ErgoRoleInterface } from '../models/ergo-role.model';
import { RoleInterface } from '../models/role.model';

@Injectable()
export class RoleRestConnectorService extends RestConnectorService {
  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>) {
    super(_store);
  }

  public loadAllRoles(): Observable<RoleInterface[]> {
    return this._httpClient.get<RoleInterface[]>(
      '/api/roles',
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<RoleInterface[]>) => httpResponse.body),
    );
  }

  public loadAllErgoRoles(): Observable<ErgoRoleInterface[]> {
    return this._httpClient.get<ErgoRoleInterface[]>(
      '/api/roles/ergo-roles',
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<ErgoRoleInterface[]>) => httpResponse.body),
    );
  }

}
